import { STAGES_P } from '../../core/constants.js';
import { ico } from '../../core/icons.js';
import { avs, cname, me, pStatus, pcode, stageOf, team } from '../../core/selectors.js';
import { S, UI } from '../../core/store.js';
import { daysTo, esc } from '../../core/util.js';

export function stagePill(st){return `<span class="spill" style="--c:${st.c}"><i class="dot"></i>${esc(st.name)}</span>`}

export function nextTask(p){return p.tasks.filter(t=>t.status!=='done'&&t.due).sort((a,b)=>a.due.localeCompare(b.due))[0]}

export function overdueN(p){return p.tasks.filter(t=>t.status!=='done'&&t.due&&daysTo(t.due)<0).length}

export function health(p){
  if(pStatus(p)==='completed')return null;
  if(p.due&&daysTo(p.due)<0)return {t:'Late',c:'bad'};
  const o=overdueN(p);if(o)return {t:o+' overdue',c:'bad'};
  return {t:'On track',c:'ok'};
}

export function projFilter(){
  const q=(UI.pq||'').toLowerCase();
  const list=S.projects.filter(p=>{const st=stageOf(p);
    return (UI.pf==='all'||pStatus(p)===UI.pf)&&(UI.ps==='all'||st.id===UI.ps)&&(UI.pw==='all'||team(p).includes(UI.pw))&&(!q||(pcode(p)+' '+p.title+' '+cname(p.code)).toLowerCase().includes(q))});
  list.sort((a,b)=>UI.po==='due'?(a.due||'9999').localeCompare(b.due||'9999'):b.num-a.num);return list;
}

export const SGROUPS=[{id:'plan',n:'Planning',s:['onb','pre','des']},{id:'prod',n:'Production',s:['shoot']},{id:'post',n:'Post-production',s:['pp','pv']},{id:'wrap',n:'Wrapping up',s:['pd']},{id:'done',n:'Completed',s:['done']}];

export function projRow(p){
  const st=stageOf(p);
  return `<article class="prow2" data-act="openp" data-p="${p.id}" tabindex="0" role="button" aria-label="Open ${esc(pcode(p))}"><div class="pid">#${p.num}<span>${p.code}</span></div><div class="pn"><h3>${esc(p.title)}</h3><p>${esc(cname(p.code))}</p></div><div>${stagePill(st)}</div><div class="pav">${avs(team(p),26)}</div></article>`;
}

export function projBoard(list){
  return `<div class="pipe pboard">${STAGES_P.map(s=>{const ps=list.filter(p=>stageOf(p).id===s.id);
    return `<div class="col" data-pcol="${s.id}"><div class="col-h"><i class="dot" style="--c:${s.c}"></i><b>${esc(s.name)}</b><span class="n">${ps.length}</span></div>${ps.map(p=>`<div class="deal" draggable="true" data-pcard="${p.id}" data-act="openp" data-p="${p.id}"><span class="pcode">${esc(pcode(p))}</span><b>${esc(p.title)}</b><span class="sub">${esc(cname(p.code))}</span><div class="row"><span></span>${avs(team(p),20)}</div></div>`).join('')||'<div class="sub" style="padding:8px 6px">Nothing at this stage</div>'}</div>`}).join('')}</div>`;
}

export function groupProjects(list){
  if(UI.pg==='client'){const m={};list.forEach(p=>{(m[p.code]=m[p.code]||[]).push(p)});return Object.keys(m).sort((a,b)=>cname(a).localeCompare(cname(b))).map(c=>({id:'c-'+c,n:cname(c),items:m[c]}))}
  if(UI.pg==='none')return [{id:'all',n:'',items:list}];
  return STAGES_P.map(g=>({id:g.id,n:g.name,c:g.c,items:list.filter(p=>stageOf(p).id===g.id)}));
}

export function plistHtml(){
  const list=projFilter();
  if(!list.length)return `<div class="card empty"><b>No projects match</b>Clear the search, or lock in a deal to start a new project.</div>`;
  if(UI.pview==='board')return projBoard(list);
  return groupProjects(list).filter(g=>g.items.length).map(g=>{
    if(!g.n)return g.items.map(projRow).join('');
    const closed=!!UI.pcol[g.id]&&!(g.id==='done'&&UI.pf==='completed');
    return `<section class="gsec"><button class="gh" data-act="ptoggle" data-g="${g.id}" aria-expanded="${!closed}">${ico('down',16)}${g.c?`<i class="dot" style="--c:${g.c}"></i>`:''}<h2>${esc(g.n)}</h2><span class="chip">${g.items.length}</span></button>${closed?'':g.items.map(projRow).join('')}</section>`}).join('');
}

export function vProjects(){
  return `<div class="page"><div class="phead"><div><h1>Projects</h1><p>Everything in the studio, grouped by where it is at.</p></div>${me().perm.proj?`<button class="btn pri" data-act="newproj">${ico('plus',16)}New project</button>`:''}</div>
  <div class="tools"><div class="seg">${[['active','Active'],['completed','Completed'],['all','All']].map(a=>`<button class="${UI.pf===a[0]?'on':''}" data-act="pfilter" data-f="${a[0]}">${a[1]}</button>`).join('')}</div>
  <select class="in sel" data-chg="pgroup" aria-label="Group projects by"><option value="stage" ${UI.pg==='stage'?'selected':''}>Group by stage</option><option value="client" ${UI.pg==='client'?'selected':''}>Group by client</option><option value="none" ${UI.pg==='none'?'selected':''}>No grouping</option></select>
  <div class="search">${ico('search',16)}<input class="in" placeholder="Search projects or clients" data-inp="psearch" value="${esc(UI.pq)}" aria-label="Search projects"></div>
  <div class="seg"><button class="${UI.pview==='list'?'on':''}" data-act="pview" data-v="list" aria-label="List view">${ico('list',16)}</button><button class="${UI.pview==='board'?'on':''}" data-act="pview" data-v="board" aria-label="Board by stage">${ico('projects',16)}</button></div></div>
  <div id="plist">${plistHtml()}</div></div>`;
}
